"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearOverrides = exports.applyOverrides = exports.toError = exports.pickChildToRender = exports.isClientAlreadyInCorrectState = void 0;
const react_1 = __importDefault(require("react"));
const feature_gate_js_client_1 = __importDefault(require("@atlaskit/feature-gate-js-client"));
let hasWarnedAboutMissingOverrideSupport = false;
function isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return (((_a = feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call(feature_gate_js_client_1.default)) &&
        ((_b = feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call(feature_gate_js_client_1.default, identifiers, customAttributes)));
}
exports.isClientAlreadyInCorrectState = isClientAlreadyInCorrectState;
function pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if (initializingComponent != null) {
        return react_1.default.createElement(react_1.default.Fragment, null, initializingComponent);
    }
    return null;
}
exports.pickChildToRender = pickChildToRender;
function toError(err) {
    if (err instanceof Error) {
        return err;
    }
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
exports.toError = toError;
function applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides &&
        (!feature_gate_js_client_1.default.overrideGate || !feature_gate_js_client_1.default.overrideConfig)) {
        if (!hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value]) => {
        var _a;
        (_a = feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 ? void 0 : _a.call(feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values]) => {
        var _a;
        (_a = feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 ? void 0 : _a.call(feature_gate_js_client_1.default, configName, values);
    });
}
exports.applyOverrides = applyOverrides;
function clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName) => {
        var _a;
        (_a = feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 ? void 0 : _a.call(feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName) => {
        var _a;
        (_a = feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 ? void 0 : _a.call(feature_gate_js_client_1.default, configName);
    });
}
exports.clearOverrides = clearOverrides;
